{
  "version": 1,
  "asset_id": "75c969b1-d581-4610-912b-6126b2f54acd",
  "project_id": "a3e359cb-5308-4f2a-8ac0-def799d4abdd",
  "url": "/__l5e/assets-v1/75c969b1-d581-4610-912b-6126b2f54acd/thumb-selfie.webp",
  "r2_key": "a/v1/a3e359cb-5308-4f2a-8ac0-def799d4abdd/75c969b1-d581-4610-912b-6126b2f54acd/thumb-selfie.webp",
  "original_filename": "thumb-selfie.webp",
  "size": 65662,
  "content_type": "image/webp",
  "created_at": "2026-08-30T13:03:27Z"
}
